import { NofeshService } from './../../nofesh/nofesh.service';

import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { AppSettings } from "../../shared/app-settings";
import { NofshonimService } from '../nofshonim.service';
import { UploadService } from '../../shared/upload.service';
import { INofeshUploads } from '../../nofesh/model/nofesh-uploads';
import { MenuHandler } from "app/shared/menu-handler";
import { INofesh } from '../../nofesh/model/nofesh';
import { INofshonNirshamim } from '../model/nofshon-nirshamim';
import { INofshonNirsham } from '../model/nofshon-nirsham';
import { ENofeshType } from '../../shared/enums/enofesh-type.enum';
import { ConfigService } from 'app/shared/config.service';
declare var $: any;

@Component({
    moduleId: module.id,
    templateUrl: './nofshon-chul-uploads.component.html',
    providers: [UploadService]
})

export class NofshonUploadsComponent implements OnInit {

    constructor(private _nofshonimService: NofshonimService, private _router: Router, private _uploadService: UploadService, private _activateRoute: ActivatedRoute,
        private _configService: ConfigService) 
        {
            this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
        }
    reservationId: number;
    nofeshUploads: INofeshUploads[]
    is_submited: boolean = false;
    is_update_mode: boolean = false;  // If True the user came from main page
    nofesh_id: number;
    ms_zehut_mazmim: number;
    nirshamim: INofshonNirshamim;
    apiUrl: string = "";

    ngOnInit(): void {
        MenuHandler.menuHandler($(".wiz_group"), $("#li_files"));
        
        //#region Get reservetionID
        this.reservationId = this._activateRoute.snapshot.params['id'];
        if (this.reservationId == null || this.reservationId == undefined || this.reservationId == 0) 
        {
            let orderNofesh = sessionStorage.getItem('nofshon-nirshamim');

            if (orderNofesh == null) 
            {
                this._router.navigateByUrl('/nofesh');
                return;
            }
        }
        else 
        {
            this.is_update_mode = true;
        }
        //#endregion
        
        
        this.nirshamim = JSON.parse(sessionStorage.getItem('nofshon-nirshamim'));
        if (this.nirshamim != null) 
        {
            this.nofesh_id = this.nirshamim.nirshamim[0].id_nofesh;
            this.ms_zehut_mazmim = this.nirshamim.nirshamim[0].ms_zehut_mazmin;

            this._nofshonimService.getNofshonUploads(this.nofesh_id)
                .subscribe(r => {
                    this.nofeshUploads = r.filter(x => x.is_uploaded == false);
                });              
        }
        else 
        {
            let userSelectedNofesh = sessionStorage.getItem('userSelectedNofesh');
            if (userSelectedNofesh != null) 
            {
                this.nofesh_id = JSON.parse(userSelectedNofesh).id_nofesh;
                this._nofshonimService.getPirteyNofshim(this.nofesh_id)
                .subscribe((r :INofshonNirsham[]) => {
                        sessionStorage.setItem('nirshamim', JSON.stringify(r));
                        this.nirshamim = { nirshamim: r };
                        if (r.length > 0) 
                        {
                            this.ms_zehut_mazmim = r[0].ms_zehut;
                            sessionStorage.setItem('ms_zehut_mazmin', JSON.stringify(this.ms_zehut_mazmim));
                        }
                        this._nofshonimService.getNofshonUploads(this.nofesh_id)
                            .subscribe(r => {
                                this.nofeshUploads = r.filter(x => x.is_uploaded == false);
                            });
                    }, 
                    error => {
                        if (error.includes("401")) {
                            localStorage.removeItem("token");
                            location.reload();
                        }
                    })
            }
            else
            {
                this._router.navigateByUrl('/nofesh');
            }
        }
        
    

        // this._http.getNofeshUploads(this.nofesh_id, this.ms_zehut_mazmim)
        //     .subscribe(r => this.nofeshUploads = r.filter(x => x.is_uploaded == false));
    }

    fileChange($event, i: number) {

        this.nofeshUploads[i].file = null;
        this.nofeshUploads[i].fileName = "";

        if ($event.srcElement.files[0].size / 1024 / 1024 > 10) {
            this.nofeshUploads[i].fileName = "גודל הקובץ חורג מהמותר. הקובץ לא יצורף.";
            return;
        }
        var strExtension = ".jpg,.gif,.png,.docx,.pdf,.tif,.jpeg";
        if (strExtension.indexOf($event.srcElement.files[0].name.split('.').pop().toLowerCase()) == -1) {
            this.nofeshUploads[i].fileName = "קובץ לא תקין. הקובץ לא יצורף.";
            return;
        }

        this.nofeshUploads[i].file = $event.srcElement.files[0];
        this.nofeshUploads[i].fileName = $event.srcElement.files[0].name;
    }

    removefile(i: number) {
        this.nofeshUploads[i].file = null;
        this.nofeshUploads[i].fileName = "";
    }

    save(event): void {
        event.preventDefault();
        this.is_submited = true;

        let param: string[] = [];
        let files: File[] = [];
        this.nofeshUploads.forEach(e => {
            if (e.file) {
                param.push(this.nofesh_id + '_' + e.ms_zehut + '_' + e.ms_kod);
                files.push(e.file);
            }
        });
        
        this._uploadService.makeFileRequest(`${this.apiUrl}/api/Nofesh/SaveNofshonUploads`, param, files).subscribe({complete: () => {
            //marked it since we don't need to get to end-rishum anymore after uploading files
            
            // if(this.nirshamim.nirshamim[0].nofesh_type == ENofeshType.NofeshChul)
            // {
            //      this._router.navigate(['nofshonim-chul', 'end-rishum']);
                
            // }
            // else if(this.nirshamim.nirshamim[0].nofesh_type == ENofeshType.MishpachotChul)
            // {
            //      this._router.navigate(['mishpachot-chul', 'end-rishum']);
               
            // }

            this._router.navigate(['/nofesh']);
        }, 
        error: err => {
            console.log('error occurred: ' + err);
            this._router.navigate(['/nofesh']);

            //marked it since we don't need to get to end-rishum anymore after uploading files

            // if(this.nirshamim.nirshamim[0].nofesh_type == ENofeshType.NofeshChul)
            // {
            //     this._router.navigate(['nofshonim-chul', 'end-rishum']);
            // }
            // else if(this.nirshamim.nirshamim[0].nofesh_type == ENofeshType.MishpachotChul)
            // {
            //     this._router.navigate(['mishpachot-chul', 'end-rishum']);
            // }
        }
    });

   // this._router.navigate(['nofshonim-chul', 'end-rishum']);
    }

    getBackLink() 
    {
        // if (this.is_update_mode) 
        // { 
        //     this._router.navigateByUrl('/nofesh'); 
        // }
        // else 
        // { 
        //     if(this.nirshamim.nirshamim[0].nofesh_type == ENofeshType.NofeshChul)
        //     {
        //         this._router.navigateByUrl(`/nofshonim-chul/pirtey-tashlum/${this.nofesh_id}`); 
        //     }
        //     else if(this.nirshamim.nirshamim[0].nofesh_type == ENofeshType.MishpachotChul)
        //     {
        //         this._router.navigateByUrl(`/mishpachot-chul/pirtey-tashlum/${this.nofesh_id}`); 
        //     }
        //     //this._router.navigateByUrl('/nofesh/nofesh-payment/' + this.nofesh_id); 
        // }
        this._router.navigateByUrl('/nofesh'); 

    }
    menuHandler(t, id) {
        $("#menu_ul_id").find('li').removeClass("wiz-selected-step");
        $("#menu_ul_id").find(".wiz-num").removeClass("wiz-selected-num");

        id.toggleClass('wiz-selected-step');
        id.find(".wiz-num").toggleClass("wiz-selected-num");

        $(t).find('small.fa').remove()


        if ($(t).find('.wiz-selected-step').length == 0)
            return;
        var index = $(t).find('.wiz-selected-step').index();
        var amount = parseInt($(t).find('.wiz_group').data('wiz-steps'));
        if (amount <= 0)
            return;
        var colWidth = 100 / amount * 0.99;
        $(t).find('.wiz_group').append('<small class="fa fa-caret-down wiz-current-indiction" style="width:' + colWidth + '%; margin-right:' + (colWidth * (index)) + '%;"></small>');

        this._setWizardSteps();

        this.updateHeaderTitle();
    }

    _setWizardSteps() {

        var $wizGroup = $('.wiz_group');
        if (!$wizGroup || !$wizGroup.data('wiz-steps'))
            return;
        var stepsCount = parseInt($wizGroup.data('wiz-steps'));
        var $steps = $('.wiz_group>ol>li');

        if ($steps.length > 0) {
            $steps.css('width', 100 / stepsCount + '%');
            $('.wiz-current-indiction').css('width', 100 / stepsCount + '%');

            var nextStepText = $($steps[1]).find('.wiz-text').text();
            $('.next-step').attr('title', nextStepText);
        }
    }

    updateHeaderTitle() {
        var wiz_num = $(".wiz-selected-num");
        var wiz_text = $(".wiz-selected-num").next();

        if (wiz_num.text().length > 0 && wiz_text.text().length > 0) {
            var title = $("#layouHeader").attr("title")
            title = title + " שלב " + wiz_num.text() + " - " + wiz_text.text();
            $("#layouHeader").attr("title", title);
        }
        else {
            //$("#layouHeader").attr("title", "עיריית תל אביב - רישום גני ילדים וחינוך יסודי");
        }
    }
}